
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StoreModel } from '@/models/store';
import { featureUnlockService } from '@/services/FeatureUnlockService';
import { postUnlockReviewService } from '@/services/PostUnlockReviewService';

@Component
export default class FeatureUnlockModal extends Vue {
  @Prop({ default: false })
  public value!: boolean;

  @Prop({ default: '' })
  public featureCode!: string;

  @Prop({ default: '' })
  public featureName!: string;

  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;

  public step: string = 'survey';
  public selectedAnswer: string = '';
  public freeText: string = '';
  public submitting: boolean = false;
  public errorMessage: string = '';

  public readonly surveyQuestion: string = "What's the #1 use case you'll use this feature for?";

  public readonly answerOptions = [
    { value: 'track_performance', label: 'Track product/sales performance' },
    { value: 'optimize_inventory', label: 'Optimize inventory levels' },
    { value: 'share_reports', label: 'Share reports with my team' },
    { value: 'make_purchasing_decisions', label: 'Make better purchasing decisions' },
    { value: 'analyze_trends', label: 'Analyze trends over time' },
    { value: 'other', label: 'Other' },
  ];

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit('input', val);
  }

  public async submitSurvey() {
    if (!this.selectedAnswer) return;

    this.submitting = true;
    this.errorMessage = '';

    try {
      const selectedOption = this.answerOptions.find(o => o.value === this.selectedAnswer);
      const surveyResponse = {
        answer: this.selectedAnswer,
        answerLabel: selectedOption ? selectedOption.label : this.selectedAnswer,
        freeText: this.selectedAnswer === 'other' ? this.freeText : undefined,
      };

      await featureUnlockService.createUnlock(
        this.featureCode,
        this.surveyQuestion,
        surveyResponse,
        'inline_unlock_v1',
      );

      // Don't call store.getRules() here — it clears rules first which
      // causes Permission to hide the slot, destroying this modal.
      // Rules will refresh on page reload after user clicks "Start Using".
      this.step = 'success';

      // Register for delayed review request (Flow C)
      postUnlockReviewService.registerUnlock(this.featureCode, this.store.id);
    } catch (error: any) {
      this.errorMessage = 'Something went wrong. Please try again.';
      console.error('[FeatureUnlock] Error:', error);
    } finally {
      this.submitting = false;
    }
  }

  public startUsing() {
    this.$emit('unlocked', this.featureCode);
    this.dialog = false;
  }

  public close() {
    this.dialog = false;
  }

  public goToUpgrade() {
    this.dialog = false;
    this.$router.push('/subscription');
  }

  @Watch('value')
  private onValueChange(newVal: boolean) {
    if (!newVal) {
      setTimeout(() => this.resetState(), 300);
    }
  }

  private resetState() {
    this.step = 'survey';
    this.selectedAnswer = '';
    this.freeText = '';
    this.submitting = false;
    this.errorMessage = '';
  }
}
